import React, { createContext, useContext, useMemo, useState, ReactNode } from "react";
import { QuestionnaireViewModel } from "../utils/ServiceManagerAPI";

interface EntitiesContextType {
    entities: QuestionnaireViewModel[];
    setEntities: (entities: QuestionnaireViewModel[]) => void;
    getEntityById: (id: string) => QuestionnaireViewModel | null;
}

const EntitiesContext = createContext<EntitiesContextType>({
    entities: [],
    setEntities: () => {},
    getEntityById: () => null,
});

export const useEntities = () => useContext(EntitiesContext);

interface EntitiesProviderProps {
    children: ReactNode;
}

export const EntitiesProvider = ({ children }: EntitiesProviderProps) => {
    const [entities, setEntities] = useState<QuestionnaireViewModel[]>([]);

    const value = useMemo(
        () => ({
            entities,
            setEntities,
            getEntityById: (id: string) => entities.find((entity) => entity.id === id) || null,
        }),
        [entities]
    );

    return <EntitiesContext.Provider value={value}>{children}</EntitiesContext.Provider>;
};
